module.exports = __webpack_public_path__ + "static/img/16.2ce537b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/16.jpg
// module id = McLQ
// module chunks = 1